export const LCObTokens = {
  actionColorBgBrand: 'rgba(34, 34, 34, 1)',
  actionColorBgBrandA0: 'rgba(34, 34, 34, 0)',
  actionColorBgBrandA0Inverse: 'rgba(255, 255, 255, 0)',
  actionColorBgBrandAlpha: 'rgba(34, 34, 34, 0.2)',
  actionColorBgBrandAlphaInverse: 'rgba(34, 34, 34, 0.2)',
  actionColorBgBrandHover: 'rgba(118, 118, 118, 1)',
  actionColorBgBrandInverse: 'rgba(255, 255, 255, 1)',
  actionColorBgBrandInverseHover: 'rgba(246, 246, 246, 1)',
  actionColorBgDarkA0: 'rgba(34, 34, 34, 0)',
  actionColorBgDarkA20: 'rgba(34, 34, 34, 0.2)',
  actionColorBgDarkA50: 'rgba(34, 34, 34, 0.5)',
  actionColorBgDisabled: 'rgba(34, 34, 34, 0.5)',
  actionColorBgDisabledInverse: 'rgba(255, 255, 255, 0.5)',
  actionColorBgLightA0: 'rgba(255, 255, 255, 0)',
  actionColorBgLightA20: 'rgba(255, 255, 255, 0.2)',
  actionColorBgLightA50: 'rgba(255, 255, 255, 0.5)',
  actionColorBgSecondary: 'rgba(255, 255, 255, 1)',
  actionColorBgSecondaryHover: 'rgba(246, 246, 246, 1)',
  actionColorBgSecondaryInverse: 'rgba(34, 34, 34, 1)',
  actionColorBgSecondaryInverseHover: 'rgba(118, 118, 118, 1)',
  actionColorBgTertiary: 'rgba(85, 123, 146, 1)',
  actionColorBgTertiaryHover: 'rgba(25, 44, 80, 1)',
  actionColorBgTertiaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorBgTertiaryInverseHover: 'rgba(246, 246, 246, 1)',
  actionColorBordersBrand: 'rgba(34, 34, 34, 1)',
  actionColorBordersBrandA0: 'rgba(34, 34, 34, 0)',
  actionColorBordersBrandAlpha: 'rgba(34, 34, 34, 0.2)',
  actionColorBordersBrandHover: 'rgba(118, 118, 118, 1)',
  actionColorBordersBrandInverse: 'rgba(255, 255, 255, 1)',
  actionColorBordersBrandInverseHover: 'rgba(255, 255, 255, 1)',
  actionColorBordersDarkA0: 'rgba(255, 255, 255, 0)',
  actionColorBordersDarkA20: 'rgba(255, 255, 255, 0.2)',
  actionColorBordersDarkA50: 'rgba(255, 255, 255, 0.5)',
  actionColorBordersDisabled: 'rgba(34, 34, 34, 0.5)',
  actionColorBordersDisabledInverse: 'rgba(255, 255, 255, 0.5)',
  actionColorBordersLightA0: 'rgba(255, 255, 255, 0)',
  actionColorBordersLightA20: 'rgba(34, 34, 34, 0.2)',
  actionColorBordersLightA50: 'rgba(34, 34, 34, 0.5)',
  actionColorBordersLink: 'rgba(34, 34, 34, 1)',
  actionColorBordersLinkHover: 'rgba(118, 118, 118, 1)',
  actionColorBordersLinkHoverInverse: 'rgba(255, 255, 255, 1)',
  actionColorBordersLinkInverse: 'rgba(255, 255, 255, 1)',
  actionColorBordersSecondary: 'rgba(255, 255, 255, 1)',
  actionColorBordersSecondaryHover: 'rgba(255, 255, 255, 1)',
  actionColorBordersSecondaryInverse: 'rgba(34, 34, 34, 1)',
  actionColorBordersSecondaryInverseHover: 'rgba(0, 0, 0, 1)',
  actionColorBordersTertiary: 'rgba(85, 123, 146, 1)',
  actionColorBordersTertiaryHover: 'rgba(25, 44, 80, 1)',
  actionColorBordersTertiaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorBordersTertiaryInverseHover: 'rgba(255, 255, 255, 1)',
  actionColorTextBrand: 'rgba(255, 255, 255, 1)',
  actionColorTextBrandHover: 'rgba(255, 255, 255, 1)',
  actionColorTextBrandInverse: 'rgba(34, 34, 34, 1)',
  actionColorTextBrandInverseHover: 'rgba(0, 0, 0, 1)',
  actionColorTextDisabled: 'rgba(118, 118, 118, 1)',
  actionColorTextDisabledInverse: 'rgba(172, 172, 172, 1)',
  actionColorTextLink: 'rgba(34, 34, 34, 1)',
  actionColorTextLinkHover: 'rgba(118, 118, 118, 1)',
  actionColorTextLinkHoverInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkSecondary: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkSecondaryHover: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkSecondaryHoverInverse: 'rgba(0, 0, 0, 1)',
  actionColorTextLinkSecondaryInverse: 'rgba(34, 34, 34, 1)',
  actionColorTextLinkTertiary: 'rgba(85, 123, 146, 1)',
  actionColorTextLinkTertiaryHover: 'rgba(25, 44, 80, 1)',
  actionColorTextLinkTertiaryHoverInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkTertiaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextSecondary: 'rgba(34, 34, 34, 1)',
  actionColorTextSecondaryHover: 'rgba(0, 0, 0, 1)',
  actionColorTextSecondaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextSecondaryInverseHover: 'rgba(255, 255, 255, 1)',
  actionColorTextTertiary: 'rgba(255, 255, 255, 1)',
  actionColorTextTertiaryHover: 'rgba(255, 255, 255, 1)',
  actionColorTextTertiaryInverse: 'rgba(34, 34, 34, 1)',
  actionColorTextTertiaryInverseHover: 'rgba(34, 34, 34, 1)',
  bgColorAlphaBrandA0: 'rgba(85, 123, 146, 0)',
  bgColorAlphaBrandPrimary: 'rgba(85, 123, 146, 0.2)',
  bgColorAlphaDarkA0: 'rgba(34, 34, 34, 0)',
  bgColorAlphaDarkA20: 'rgba(34, 34, 34, 0.2)',
  bgColorAlphaDarkA50: 'rgba(34, 34, 34, 0.5)',
  bgColorAlphaInverseBrandA0: 'rgba(85, 123, 146, 0)',
  bgColorAlphaInverseBrandPrimary: 'rgba(85, 123, 146, 0.2)',
  bgColorAlphaLightA0: 'rgba(255, 255, 255, 0)',
  bgColorAlphaLightA20: 'rgba(255, 255, 255, 0.2)',
  bgColorAlphaLightA50: 'rgba(255, 255, 255, 0.5)',
  bgColorBaseDefault: 'rgba(255, 255, 255, 1)',
  bgColorBaseInverseDefault: 'rgba(34, 34, 34, 1)',
  bgColorBaseInverseSecondary: 'rgba(118, 118, 118, 1)',
  bgColorBaseInverseTertiary: 'rgba(176, 176, 176, 1)',
  bgColorBaseSecondary: 'rgba(246, 246, 246, 1)',
  bgColorBaseTertiary: 'rgba(216, 216, 216, 1)',
  bgColorBrandInversePrimary: 'rgba(255, 255, 255, 1)',
  bgColorBrandInversePrimaryHover: 'rgba(255, 255, 255, 1)',
  bgColorBrandInverseSecondary: 'rgba(240, 234, 226, 1)',
  bgColorBrandInverseSecondaryHover: 'rgba(240, 234, 226, 1)',
  bgColorBrandInverseTertiary: 'rgba(231, 238, 240, 1)',
  bgColorBrandInverseTertiaryHover: 'rgba(231, 238, 240, 1)',
  bgColorBrandPrimary: 'rgba(34, 34, 34, 1)',
  bgColorBrandPrimaryHover: 'rgba(25, 44, 80, 1)',
  bgColorBrandSecondary: 'rgba(240, 234, 226, 1)',
  bgColorBrandSecondaryHover: 'rgba(240, 234, 226, 1)',
  bgColorBrandTertiary: 'rgba(231, 238, 240, 1)',
  bgColorBrandTertiaryHover: 'rgba(231, 238, 240, 1)',
  bgColorFunctionalDisabled: 'rgba(216, 216, 216, 1)',
  bgColorFunctionalError: 'rgba(253, 225, 225, 1)',
  bgColorFunctionalInfo: 'rgba(220, 237, 252, 1)',
  bgColorFunctionalInverseDisabled: 'rgba(216, 216, 216, 1)',
  bgColorFunctionalInverseError: 'rgba(54, 4, 4, 1)',
  bgColorFunctionalInverseInfo: 'rgba(5, 34, 58, 1)',
  bgColorFunctionalInverseSuccess: 'rgba(18, 61, 46, 1)',
  bgColorFunctionalInverseWarning: 'rgba(60, 55, 5, 1)',
  bgColorFunctionalSuccess: 'rgba(214, 243, 233, 1)',
  bgColorFunctionalWarning: 'rgba(252, 249, 219, 1)',
  bgColorPromoInverseDefaultG1: 'rgba(118, 118, 118, 1)',
  bgColorPromoDefaultG1: 'rgba(240, 234, 226, 1)',
  bgColorPromoDefaultG2: 'rgba(240, 234, 226, 1)',
  bgColorPromoInverseDefaultG2: 'rgba(118, 118, 118, 1)',
  bgColorPromoInverseSecondaryG1: 'rgba(118, 118, 118, 1)',
  bgColorPromoInverseSecondaryG2: 'rgba(118, 118, 118, 1)',
  bgColorPromoInverseTertiaryG1: 'rgba(255, 255, 255, 1)',
  bgColorPromoInverseTertiaryG2: 'rgba(255, 255, 255, 1)',
  bgColorPromoSecondaryG1: 'rgba(231, 238, 240, 1)',
  bgColorPromoSecondaryG2: 'rgba(231, 238, 240, 1)',
  bgColorPromoTertiaryG1: 'rgba(36, 76, 90, 1)',
  bgColorPromoTertiaryG2: 'rgba(36, 76, 90, 1)',
  bordersColorBrandPrimary: 'rgba(34, 34, 34, 1)',
  bordersColorBrandPrimaryHover: 'rgba(25, 44, 80, 1)',
  bordersColorBrandPrimaryHoverInverse: 'rgba(25, 44, 80, 1)',
  bordersColorBrandPrimaryInverse: 'rgba(255, 255, 255, 1)',
  bordersColorBrandSecondary: 'rgba(240, 234, 226, 1)',
  bordersColorBrandSecondaryHover: 'rgba(240, 234, 226, 1)',
  bordersColorBrandSecondaryHoverInverse: 'rgba(240, 234, 226, 1)',
  bordersColorBrandSecondaryInverse: 'rgba(240, 234, 226, 1)',
  bordersColorBrandTertiary: 'rgba(231, 238, 240, 1)',
  bordersColorBrandTertiaryHover: 'rgba(231, 238, 240, 1)',
  bordersColorBrandTertiaryHoverInverse: 'rgba(231, 238, 240, 1)',
  bordersColorBrandTertiaryInverse: 'rgba(231, 238, 240, 1)',
  bordersColorFunctionalDisabled: 'rgba(176, 176, 176, 1)',
  bordersColorFunctionalDisabledInverse: 'rgba(176, 176, 176, 1)',
  bordersColorFunctionalError: 'rgba(227, 33, 24, 1)',
  bordersColorFunctionalErrorInverse: 'rgba(227, 33, 24, 1)',
  bordersColorFunctionalFocus: 'rgba(85, 123, 146, 1)',
  bordersColorFunctionalFocusInverse: 'rgba(85, 123, 146, 1)',
  bordersColorFunctionalInfo: 'rgba(20, 101, 180, 1)',
  bordersColorFunctionalInfoInverse: 'rgba(20, 101, 180, 1)',
  bordersColorFunctionalSuccess: 'rgba(36, 117, 52, 1)',
  bordersColorFunctionalSuccessInverse: 'rgba(36, 117, 52, 1)',
  bordersColorFunctionalWarning: 'rgba(220, 159, 3, 1)',
  bordersColorFunctionalWarningInverse: 'rgba(220, 159, 3, 1)',
  bordersColorNeutralDefault: 'rgba(255, 255, 255, 1)',
  bordersColorNeutralInverseDefault: 'rgba(34, 34, 34, 1)',
  bordersColorNeutralInverseSecondary: 'rgba(118, 118, 118, 1)',
  bordersColorNeutralInverseTertiary: 'rgba(118, 118, 118, 1)',
  bordersColorNeutralSecondary: 'rgba(216, 216, 216, 1)',
  bordersColorNeutralTertiary: 'rgba(176, 176, 176, 1)',
  textColorBaseDefault: 'rgba(34, 34, 34, 1)',
  textColorBaseInverseDefault: 'rgba(255, 255, 255, 1)',
  textColorBaseInverseSecondary: 'rgba(255, 255, 255, 1)',
  textColorBaseInverseTertiary: 'rgba(255, 255, 255, 1)',
  textColorBaseSecondary: 'rgba(118, 118, 118, 1)',
  textColorBaseTertiary: 'rgba(118, 118, 118, 1)',
  textColorBrandPrimary: 'rgba(25, 44, 80, 1)',
  textColorBrandPrimaryInverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo1: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo1Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo2: 'rgba(36, 76, 90, 1)',
  textColorBrandPromo2Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo3: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo3Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo4: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo4Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandSecondary: 'rgba(85, 123, 146, 1)',
  textColorBrandSecondaryInverse: 'rgba(255, 255, 255, 1)',
  textColorBrandTertiary: 'rgba(36, 76, 90, 1)',
  textColorBrandTertiaryInverse: 'rgba(255, 255, 255, 1)',
  textColorFunctionalDisabled: 'rgba(118, 118, 118, 1)',
  textColorFunctionalDisabledInverse: 'rgba(172, 172, 172, 1)',
  textColorFunctionalError: 'rgba(227, 33, 24, 1)',
  textColorFunctionalErrorInverse: 'rgba(255, 139, 136, 1)',
  textColorFunctionalInfo: 'rgba(20, 101, 180, 1)',
  textColorFunctionalInfoInverse: 'rgba(121, 181, 240, 1)',
  textColorFunctionalInverseLink: 'rgba(255, 255, 255, 1)',
  textColorFunctionalLink: 'rgba(85, 123, 146, 1)',
  textColorFunctionalLinkHover: 'rgba(85, 123, 146, 1)',
  textColorFunctionalLinkHoverInverse: 'rgba(255, 255, 255, 1)',
  textColorFunctionalSuccess: 'rgba(36, 117, 52, 1)',
  textColorFunctionalSuccessInverse: 'rgba(106, 192, 8, 1)',
  textColorFunctionalWarning: 'rgba(182, 132, 5, 1)',
  textColorFunctionalWarningInverse: 'rgba(249, 187, 30, 1)',
  actionBorderStrokeDefault: '0.0625rem',
  actionBorderStrokeHover: '0.125rem',
  actionBorderRadius: '62.4375rem',
  actionMTopMd: '0.7188rem',
  actionMBottomLg: '0.75rem',
  actionMBottomSm: '0.75rem',
  actionMTopLg: '0.75rem',
  actionMTopSm: '0.75rem',
  actionMBottomMd: '0.7812rem',
  actionMLeftSm: '1rem',
  actionMRightSm: '1rem',
  actionMLeftLg: '2rem',
  actionMLeftMd: '2rem',
  actionMRightLg: '2rem',
  actionMRightMd: '2rem',
  actionPSm: '0.25rem',
  actionPLg: '0.5rem',
  actionPMd: '0.5rem',
  bordersRadiusNone: '0rem',
  bordersRadiusSm: '0.25rem',
  bordersRadiusMd: '0.5rem',
  bordersRadiusLg: '1rem',
  bordersRadiusXl: '1.25rem',
  bordersRadiusRound: '62.4375rem',
  bordersStrokeNone: '0rem',
  bordersStrokeThinnest: '0.0625rem',
  bordersStrokeThin: '0.125rem',
  bordersStrokeMedium: '0.1875rem',
  bordersStrokeStrong: '0.25rem',
  deviceDeskMNone: '0rem',
  deviceDeskMLrSm: '1.5rem',
  deviceDeskMTbSm: '2.5rem',
  deviceDeskMLrBase: '4rem',
  deviceDeskMTbBase: '4rem',
  deviceDeskMTbLg: '5rem',
  deviceDeskMLrLg: '16rem',
  deviceDeskPNone: '0rem',
  deviceDeskPXs: '0.5rem',
  deviceDeskPSm: '1rem',
  deviceDeskPBase: '1.5rem',
  deviceDeskPLg: '2rem',
  deviceDeskRRadius: '0.25rem',
  deviceMobMNone: '0rem',
  deviceMobMLrBase: '1rem',
  deviceMobMLrLg: '1rem',
  deviceMobMLrSm: '1rem',
  deviceMobMTbSm: '1.5rem',
  deviceMobMTbBase: '2rem',
  deviceMobMTbLg: '2.5rem',
  deviceMobPNone: '0rem',
  deviceMobPXs: '0.5rem',
  deviceMobPSm: '1rem',
  deviceMobPBase: '1.5rem',
  deviceMobPLg: '2rem',
  deviceMobRRadius: '0.25rem',
  deviceTabMNone: '0rem',
  deviceTabMTbSm: '1rem',
  deviceTabMLrBase: '2rem',
  deviceTabMLrSm: '2rem',
  deviceTabMTbBase: '2rem',
  deviceTabMTbLg: '3rem',
  deviceTabMLrLg: '5rem',
  deviceTabPNone: '0rem',
  deviceTabPXs: '0.5rem',
  deviceTabPSm: '1rem',
  deviceTabPBase: '1.5rem',
  deviceTabPLg: '2rem',
  deviceTabRRadiusLandscape: '0.25rem',
  deviceTabRRadiusPortrait: '0.25rem',
  screenSizeMobile: '23.4375rem',
  screenSizeTabletPortrait: '48rem',
  screenSizeTabletLandscape: '64rem',
  screenSizeDesktop: '90rem',
  spacingsNone: '0rem',
  spacingsXs: '0.125rem',
  spacingsSm: '0.25rem',
  spacingsMd: '0.5rem',
  spacingsBase: '1rem',
  spacingsLg: '1.5rem',
  spacingsXl: '2rem',
  spacings2xl: '2.5rem',
  spacings3xl: '4rem',
  spacings4xl: '5rem',
  spacings5xl: '8rem',
  spacingsSpacingEnormous: '11rem',
  text2xlKerning: '0rem',
  text2xlSize: '1.5rem',
  text2xlLineHeight: '2.125rem',
  text3xlKerning: '0rem',
  text3xlSize: '2rem',
  text3xlLineHeight: '2.625rem',
  text4xlKerning: '0rem',
  text4xlSize: '2.5rem',
  text4xlLineHeight: '3rem',
  text5xlKerning: '0rem',
  text5xlSize: '4rem',
  text5xlLineHeight: '4.8125rem',
  text6xlKerning: '0rem',
  text6xlSize: '5rem',
  text6xlLineHeight: '6rem',
  text7xlKerning: '0rem',
  text7xlSize: '7.5rem',
  text7xlLineHeight: '9rem',
  textCTABigKerning: '0rem',
  textCTABigLineHeight: '1.25rem',
  textCTABigSize: '1.25rem',
  textCTAMediumKerning: '0rem',
  textCTAMediumLineHeight: '1rem',
  textCTAMediumSize: '1rem',
  textCTASmallKerning: '0rem',
  textCTASmallLineHeight: '0.875rem',
  textCTASmallSize: '0.875rem',
  textBaseKernng: '0rem',
  textBaseSize: '1rem',
  textBaseLineHeight: '1.5rem',
  textH1DeskKerning: '0rem',
  textH1DeskSize: '3rem',
  textH1DeskLineHeight: '3.5rem',
  textH1MobKerning: '0rem',
  textH1MobSize: '2rem',
  textH1MobLineHeight: '2.5rem',
  textH1TabKerning: '0rem',
  textH1TabSize: '2rem',
  textH1TabLineHeight: '2.375rem',
  textH2DeskKerning: '0rem',
  textH2DeskSize: '2rem',
  textH2DeskLineHeight: '2.5rem',
  textH2MobKerning: '0rem',
  textH2MobSize: '1.75rem',
  textH2MobLineHeight: '2rem',
  textH2TabKerning: '0rem',
  textH2TabSize: '1.75rem',
  textH2TabLineHeight: '2rem',
  textH3DeskKerning: '0rem',
  textH3DeskSize: '1.75rem',
  textH3DeskLineHeight: '2rem',
  textH3MobKerning: '0rem',
  textH3MobSize: '1.5rem',
  textH3MobLineHeight: '1.75rem',
  textH3TabKerning: '0rem',
  textH3TabSize: '1.5rem',
  textH3TabLineHeight: '2.5rem',
  textH4DeskKerning: '0rem',
  textH4DeskSize: '1.25rem',
  textH4DeskLineHeight: '1.75rem',
  textH4MobKerning: '0rem',
  textH4MobSize: '1.125rem',
  textH4MobLineHeight: '1.5rem',
  textH4TabKerning: '0rem',
  textH4TabSize: '1.125rem',
  textH4TabLineHeight: '1.5rem',
  textH5DeskKerning: '0rem',
  textH5DeskSize: '1.125rem',
  textH5DeskLineHeight: '1.75rem',
  textH5MobKerning: '0rem',
  textH5MobSize: '1rem',
  textH5MobLineHeight: '1.5rem',
  textH5TabKerning: '0rem',
  textH5TabSize: '1rem',
  textH5TabLineHeight: '1.5rem',
  textH6DeskKerning: '0rem',
  textH6DeskSize: '1rem',
  textH6DeskLineHeight: '1.5rem',
  textH6MobKerning: '0rem',
  textH6MobSize: '0.875rem',
  textH6MobLineHeight: '1.25rem',
  textH6TabKerning: '0rem',
  textH6TabSize: '0.875rem',
  textH6TabLineHeight: '1.25rem',
  textLgKerning: '0rem',
  textLgSize: '1.125rem',
  textLgLineHeight: '1.6875rem',
  textSmKerning: '0rem',
  textSmSize: '0.875rem',
  textSmLineHeight: '1.25rem',
  textXlKerning: '0rem',
  textXlSize: '1.25rem',
  textXlLineHeight: '1.75rem',
  textXsKerning: '0rem',
  textXsSize: '0.75rem',
  textXsLineHeight: '1rem',
  brandURL: 'lenscrafters.com',
  brandName: 'LensCrafters',
  brandingBrandFooter: 'LensCrafters',
  brandingBrandHeader: 'LensCrafters',
  brandingFavicon: 'LensCrafters',
  brandingOFF: 'Text only',
  brandingBrandLogo: 'LensCrafters Logo',
  brandingBrandPictogram: 'LensCrafters Logo',
  brandingProductImage: 'General assortment',
  text2xlFamily: 'sofia pro',
  text3xlFamily: 'sofia pro',
  text4xlFamily: 'sofia pro',
  text5xlFamily: 'sofia pro',
  text6xlFamily: 'sofia pro',
  text7xlFamily: 'sofia pro',
  textCTABigFamily: 'sofia pro',
  textCTABigWeight: 'semi bold',
  textCTAMediumFamily: 'sofia pro',
  textCTAMediumWeight: 'semi bold',
  textCTASmallFamily: 'sofia pro',
  textCTASmallWeight: 'semi bold',
  textBaseFamily: 'sofia pro',
  textCaseUppercase: 'uppercase',
  textDecorationStrikethrough: 'strikethrough',
  textDecorationUnderlined: 'underline',
  textH1Family: 'minerva-modern',
  textH1Weight: 'regular',
  textH2Family: 'minerva-modern',
  textH2Weight: 'regular',
  textH3Family: 'minerva-modern',
  textH3Weight: 'regular',
  textH4Family: 'sofia pro',
  textH4Weight: 'semi bold',
  textH5Family: 'sofia pro',
  textH5Weight: 'semi bold',
  textH6Family: 'sofia pro',
  textH6Weight: 'semi bold',
  textLgFamily: 'sofia pro',
  textSmFamily: 'sofia pro',
  textWeightBold: 'semi bold',
  textWeightDefault: 'regular',
  textXlFamily: 'sofia pro',
  textXsFamily: 'sofia pro',
};
